<template>

<com-content :loading="is.loading" class="about">

    <div class="about-opening">

        <div class="about-opening-title">{{ page.about_opening_general_title }}</div>

        <div class="about-opening-content">

            <div class="about-opening-item" v-for="day in days" :key="day">

                <div class="about-opening-item-name">{{ page['about_opening_' + day + '_text'] }}</div>
                <div class="about-opening-item-time">{{ opening[day] }}</div>

            </div>

        </div>

    </div>

    <div class="about-services">

        <div class="about-services-title">{{ page.about_services_title }}</div>

        <div class="about-services-content">

			<template v-for="(service, index) in services">

				<div v-if="data.services[service]" class="about-services-item" :key="index">

					{{ data.services[service] }}

				</div>

			</template>

        </div>

    </div>

    <div class="about-facilities">

        <div class="about-facilities-title">{{ page.about_facilities_title }}</div>

        <div class="about-facilities-content">

			<template v-for="(facility, index) in facilities">

				<div v-if="data.facilities[facility]" class="about-facilities-item" :key="index">

					{{ data.facilities[facility] }}

				</div>

			</template>
        
        </div>

    </div>

</com-content>

</template>

<script>

import comContent from './common/Content'

export default {

    components: {
        'com-content': comContent
    },

    data: function() {

        return {
            days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
            is: {
                loading: false
            },
            opening: {},
            facilities: [],
            services: []
        }

    },

    created: function() {

        this.fetch()

    },

    methods: {

        fetch: function() {

            this.is.loading = true

            this.$api.request('business/about', {
                slug: this.page.business.slug
            }).then(function(json) {

                this.opening = json.opening
                this.services = json.services
                this.facilities = json.facilities

                this.is.loading = false

            }.bind(this))

        }

    }

}

</script>

<style scoped>

.about >>> .content-body {
    display: flex;
    flex-direction: row!important;
    flex-wrap: wrap!important;
}

.is-mobile .about >>> .content-body {
    flex-direction: column!important;
}

.about-opening {
    padding: 20px;
    border: 1px solid var(--color-grey-light);
    border-radius: 4px;
    margin-bottom: 40px;
    width: 100%;
}

.is-mobile .about-opening {
    padding: 10px;
    margin-bottom: 20px;
}

.is-desktop .about-opening:hover {
    border-color: var(--color-grey-highlight);
}

.about-opening-title,
.about-services-title,
.about-facilities-title {
    font-family: "grueber",serif;
    font-size: 20px;
    line-height: 20px;
    color: var(--color-grey-dark);
    text-align: center;
    margin-bottom: 20px;
}

.is-mobile .about-opening-title,
.is-mobile .about-services-title,
.is-mobile .about-facilities-title {
    font-size: 16px;
    line-height: 16px;
}

.about-opening-content,
.about-services-content,
.about-facilities-content {
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.about-services-content,
.about-facilities-content {
    flex-wrap: wrap;
	justify-content: center;
}

.is-mobile .about-opening-content {
    flex-wrap: wrap;
}

.about-opening-item {
    width: calc(100% / 7);
}

.is-mobile .about-opening-item {
    width: 50%;
    text-align: center;
    margin-bottom: 4px;
}

.about-opening-item-name {
    font-size: 12px;
    font-weight: 700;
    color: var(--color-grey-dark);
}

.about-opening-item-time {
    font-size: 16px;
    font-weight: 400;
    margin-top: 4px;
    color: var(--color-grey-dark);
}

.about-services,
.about-facilities {
    width: calc(50% - 20px);
    padding: 20px;
    border: 1px solid var(--color-grey-light);
    border-radius: 4px;
}

.is-mobile .about-services,
.is-mobile .about-facilities {
    width: 100%;
    padding: 10px;
}

.is-desktop .about-services:hover,
.is-desktop .about-facilities:hover {
    border-color: var(--color-grey-highlight);
}

.about-services {
    margin-right: 40px;
}

.is-mobile .about-services {
    margin-right: 0px;
    margin-bottom: 20px;
}

.about-services-item,
.about-facilities-item {
    width: calc(33.3% - 4px);
	flex-shrink: 0;
    text-align: center;
    font-size: 14px;
    line-height: 18px;
    color: var(--color-grey-dark);
	border-radius: 4px;
	border: 1px solid var(--color-grey-light);
	padding: 4px 8px;
	margin: 2px;
}

.is-mobile .about-services-item,
.is-mobile .about-facilities-item {
    width: calc(50% - 4px);
}

</style>